import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../config.service';

@Injectable({
    providedIn: 'root'
})
export class RatingService {

    baseUrl!: String;

    ParseHeaders = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(public http: HttpClient,
        private commonConfigService: ConfigService) {
        this.baseUrl = this.commonConfigService.getBaseUrl();
    }

    public getLoginDetails() {
        return JSON.parse(localStorage.getItem('admin_Details') ?? '{}');
    }

    public submitRatingWithReview(productId: number, orderId: number, rating: number, title?: string, desc?: string) {
        const reqBody = {
            "rating": rating,
            "title": title,
            "description": desc,
            "productId": productId,
            "orderId": orderId,
            "userId": this.getLoginDetails().ID,
            "username": this.getLoginDetails().FirstName
        }
        var url = this.baseUrl + '/api/Rating/SubmitRating';
        return this.http.post(url, reqBody, this.ParseHeaders);
    }

    public getRating(productId: number, orderId?: number) {
        const reqBody = {
            "takeAll": true,
            "skip": 0,
            "take": 1000,
            "productId": productId,
            "orderId": orderId ? orderId : null,
            "userId": this.getLoginDetails().ID
        }
        var url = this.baseUrl + '/api/Rating/GetRatingsAndReviews';
        return this.http.post(url, reqBody, this.ParseHeaders);
    }

    public submitRatingLike(ratingId: number, isLike: boolean) {
        var url = this.baseUrl + '/api/Rating/SubmitFeedback?ratingId=' + ratingId + '&isLike=' + isLike;
        return this.http.post(url, {});
    }
}